module.exports = __webpack_public_path__ + "static/media/so.3f60af6c.svg";